import React from 'react';
import {
  makeStyles, Box, Typography, useTheme, Theme,
} from '@material-ui/core';

interface HeaderAndDescriptionProps {
  icon?: React.ReactNode;
  iconColor?: string;
  title?: React.ReactNode;
  price?: string | number;
  description?: React.ReactNode | string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  upper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  title: {
    fontWeight: 500,
    color: theme.palette.secondary.main,
  },
  price: {
    color: theme.palette.secondary.light,
    whiteSpace: 'nowrap',
    marginLeft: theme.spacing(1),
    fontWeight: 500,
  },
  desc: {
    color: theme.palette.grey['400'],
    marginTop: theme.spacing(0.25),
  },
  marginTop: {
    marginTop: theme.spacing(0.5),
  },
}));

const HeaderAndDescription = (props: HeaderAndDescriptionProps) => {
  const {
    icon, iconColor, title, price, description,
  } = props;
  const classes = useStyles();
  const theme = useTheme();

  return (
    <>
      <Box className={classes.root}>
        {icon && (
        <Box className={classes.icon} color={iconColor || theme.palette.secondary.main}>
          {icon}
        </Box>
        )}

        <Box flexGrow="1">
          {title && (
          <Box className={classes.upper}>
            <Typography className={classes.title} variant="h5">{title}</Typography>

            {price && <Typography className={classes.price} variant="h5">{price}</Typography>}
          </Box>
          )}

          {description && (
            typeof description === 'string' ? (
              <Typography
                className={`${classes.desc} ${title && description ? classes.marginTop : ''}`}
                variant="body2"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            ) : (
              <Typography
                className={`${classes.desc} ${title && description ? classes.marginTop : ''}`}
                variant="body2"
                component="div"
              >
                {description}
              </Typography>
            )
          )}
        </Box>
      </Box>
    </>
  );
};

export default HeaderAndDescription;